import { OrderApiClient } from '@fourthwall/services/dist/OrderApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useOrderCancellationQuery = createQueryHook(OrderApiClient.getOrderCancellation, {
  queryKey: ['orderCancellation'],
})
